export const SET_LOADING_DATA = '@productWithoutPictureReport/SET_LOADING_DATA';

export const GET_LIST_ALL_REQUEST = '@productWithoutPictureReport/GET_LIST_ALL_REQUEST';
export const GET_LIST_ALL_SUCCESS = '@productWithoutPictureReport/GET_LIST_ALL_SUCCESS';

export const SHARE_CSV = '@productWithoutPictureReport/SHARE_CSV';

export const SET_PAGE = '@productWithoutPictureReport/SET_PAGE';
export const SET_ROWS_COUNT = '@productWithoutPictureReport/SET_ROWS_COUNT';
export const SET_ROWS_PER_PAGE = '@productWithoutPictureReport/SET_ROWS_PER_PAGE';
export const SET_ORDER = '@productWithoutPictureReport/SET_ORDER';
export const SET_ORDERBY = '@productWithoutPictureReport/SET_ORDERBY';
